import { FilterSection } from './FilterSection';
import { Filters } from '../../types/filters';
import { Slider } from '../shared/Slider';

interface FundingFilterProps {
    filters: Filters;
    onFiltersChange: (filters: Filters) => void;
    maxFunding: number;
}

export function FundingFilter({ filters, onFiltersChange, maxFunding }: FundingFilterProps) {
    return (
        <FilterSection title="Minimum Total Funding" defaultOpen={true}>
            <Slider
                min={0}
                max={maxFunding}
                value={filters.fundingRange[0]}
                onChange={(value) => onFiltersChange({
                    ...filters,
                    fundingRange: [value, maxFunding]
                })}
                formatValue={(value) => `$${(value / 1000000).toFixed(1)}M`}
            />
        </FilterSection>
    );
} 